import {DocumentInputField} from '@/engine';
import {ChoiceFieldTypes} from '@/model/types';

export const isChoiceField = <T extends DocumentInputField>(field: T): boolean =>
  ([...ChoiceFieldTypes] as string[]).includes(field.type);
